import { useTranslation } from 'react-i18next';
import { z } from 'zod';
import i18n from '~/locales/i18n';
import { extractExpiryDateData } from '~/utils';

const useCardValidation = () => {
  const { t } = useTranslation('app');
  const locale = i18n.language;

  const userCardSchema = z.object({
    masked_card_number: z
      .string({
        required_error: t('invalidCardNumber'),
      })
      .refine((date: string) => {
        const length = date.replace(/ /g, '').length;
        return length === 16 || length === 15;
      }, t('cardNumberLengthError')),
    card_holder_name: z
      .string({
        required_error: t('invalidHolderName'),
      })
      .min(4, t('invalidHolderName'))
      .max(50, t('invalidHolderName'))
      .regex(/^[a-zA-Z\s]+$/, t('invalidHolderName')),
    card_security_code: z
      .string({
        required_error: t('invalidCvv'),
      })
      .min(3, t('invalidCvv')),
    masked_expiry_date: z
      .string({
        required_error: t('invalidExpiryDate'),
      })
      .regex(/^(0[1-9]|1[0-2])\/\d{2}$/, t('invalidExpiryDate'))
      .refine((date: string) => {
        const { month, year } = extractExpiryDateData({ date, locale });
        const currentYear = new Date().getFullYear() % 100; // Last two digits of the year
        const currentMonth = new Date().getMonth() + 1; // 1-based month
        const isValidYear =
          year > currentYear || (year === currentYear && month >= currentMonth);

        return isValidYear;
      }, t('invalidExpiryDate')),
  });

  return { userCardSchema };
};

export default useCardValidation;
